<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import PerformansRaporlariDetay from "./StrPerformansRaporlariDetay.vue";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { linewithDataChart, dashedLineChart, splineAreaChart, columnChart, columnDatalabelChart, barChart, mixedChart, radialChart, pieChart, donutChart } from "../StrGrafik/data-apex";

export default {
  mixins: [Api, Sabit],
  page: {
    title: "Performans Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Treeselect,
    PageHeader,
    PerformansRaporlariDetay,
  },
  watch: {
    secilen_donemler() {
      this.pieChart.chartOptions.labels = this.secilen_donemler;
    },
  },

  data() {
    return {
      ComboboxDonemler: [],
      ComboboxTablolar: [],
      ComboboxGostergeler: null,
      tipegore_donemler:[],
      dizi: [],
      grafik_verisi: [],
      excel_kontrol:0,
      veri: "",
      linewithDataChart: linewithDataChart,
      dashedLineChart: dashedLineChart,
      splineAreaChart: splineAreaChart,
      columnChart: columnChart,
      columnDatalabelChart: columnDatalabelChart,
      barChart: barChart,
      mixedChart: mixedChart,
      radialChart: radialChart,
      pieChart: pieChart,
      donutChart: donutChart,
      title: "Performans Raporları",
      grafik_max_deger: 0,
      secilen_grafik: 3,
      secilen_donemler: [],
      detay_gostergeler: [],
      detay_tablolar:[],
      hedef_goster:false,
      tablolar: [],
      secilen_tablolar: null,
      gostergeler: [],
      secilen_gostergeler: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      //renkler:['#0000FF','#A52A2A','#DEB887','#7FFF00','#D2691E','#FF7F50','#6495ED','#FFF8DC','#DC143C','#00FFFF'],

      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kurumsal Performans",
          active: true,
        },
        {
          text: "Performans Raporları",
          active: true,
        },
      ],

      Filter: {
        DonemId: "",
        GostergeId: "",
        TabloId: "",
        DonemAdi: "",
      },

      line_chart: false,
      dashed_line_chart: false,
      spline_chart: false,
      kolon_grafik: true,
      column_data_label_chart: false,
      bar_chart: false,
      line_column_area_chart: false,
      radial_chart: false,
      pie_chart: false,
      donut_chart: false,
      aktifmi: true,

      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

      values: [],

      pieChartx: {
        visualMap: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["Laptop", "Tablet", "Mobile", "Others", "Desktop"],
          textStyle: {
            color: "#999",
          },
        },
        color: ["#F5D36C", "#F5684C", "#A750DF", "#4CB1F5", "#49EB61"],
        series: [
          {
            name: "Oran",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },

  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

  /*  let Filter="&Approval=true&Asc=Sira"

    this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page,Filter:Filter }).then((res) => {
      let donemler = res.Data;
      if (donemler.length > 0) {
        for (var i = 0; i < donemler.length; i++) {
          if (res.Data[i].UstId == null || res.Data[i].UstId == "") {
            this.ComboboxDonemler.push(donemler[i]);
          }
        }
      }
    }); */

    let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
           
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true&Asc=Sira";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                  this.ComboboxDonemler.push(res.Data[i]);
                  
                }
              });
         
            });

    

    //  this.grafik_yukle();
  },
  mounted() {
    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },
  methods: {
    tablo_yukle() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      for (var i = 0; i < this.ComboboxDonemler.length; i++) {
        if (this.Filter.DonemId == this.ComboboxDonemler[i].Id) {
          this.Filter.DonemAdi = this.ComboboxDonemler[i].Aciklama;
        }
      }

      // Hedef Dönemlerinin gösterilip göstyerilmeyeceğini belirlemek için tipe göre dönem seçimi
      this.tipegore_donemler=[];
      let Filter = "&UstId=" + this.Filter.DonemId;
      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: this.Page, Filter: Filter + "&Asc=Sira" }).then((res) => {
          for(var i=0;i<res.Data.length;i++){

              if(this.hedef_goster==false){
                  if(res.Data[i].VeriTipi==3){
                    this.tipegore_donemler.push(res.Data[i].Id);
                  }
              } else {
                  if(res.Data[i].VeriTipi!=1){
                    this.tipegore_donemler.push(res.Data[i].Id);
                  }
              }

          }
      });

      this.tablolar = [];

      Filter = "&DonemId=" + this.Filter.DonemId+"&Asc=SiraNo";
      this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: Filter }).then((res) => {

          this.ComboboxTablolar = res.Data;

          this.tablolar.push({ id : "1", label : "Tümü", children: []})
          for (var i = 0; i < this.ComboboxTablolar.length; i++) {
            this.tablolar[0].children.push({ id: this.ComboboxTablolar[i].Id, label: this.ComboboxTablolar[i].Adi });
          }

      });

    },

    gosterge_yukle() {

    
      let Sorgu = "";

      if (this.secilen_tablolar.length > 0) {
        if (this.secilen_tablolar[0]=="1"){

          this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:"&Tip=47&Kod=1"}).then((res) => {
          
            Sorgu="&GostergeTipiId="+res.Data[0].Id;  
        
                let Filter = Sorgu+"&Asc=SiraNo&Aktif=" + !(this.aktifmi) ;
              
                this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter: Filter }).then((res) => {
                
                  this.ComboboxGostergeler = res.Data;

                  this.gostergeler.push({ id : "1", label : "Tümü", children: []})

                  for (var i = 0; i < this.ComboboxGostergeler.length; i++) {

                    for (var s = 0; s < this.ComboboxTablolar.length; s++) {

                         if (this.ComboboxTablolar[s].Id == this.ComboboxGostergeler[i].TabloId){

                            this.veri = { id: this.ComboboxGostergeler[i].Id, label: this.ComboboxGostergeler[i].Gostergesi };
                            this.gostergeler[0].children.push(this.veri);
                         }

                    }

                    

                  }

                  this.sortByLabel();

                });

          });



   

        } else {
            for (var k = 0; k < this.secilen_tablolar.length; k++) {
                Sorgu = Sorgu + "&Tabloids=" + this.secilen_tablolar[k];
            }
        }

        let Page = {
          PageNumber: "1",
          PageSize: "9999",
        };

        this.ComboboxGostergeler=[];
        this.gostergeler = [];

                    
        this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:"&Tip=47&Kod=1"}).then((res) => {
          
          Sorgu=Sorgu+"&GostergeTipiId="+res.Data[0].Id;  
        
                let Filter = Sorgu+"&Asc=SiraNo&Aktif=" + !(this.aktifmi);
             
                this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter: Filter }).then((res) => {
                
                  this.ComboboxGostergeler = res.Data;

                  this.gostergeler.push({ id : "1", label : "Tümü", children: []})

                  for (var i = 0; i < this.ComboboxGostergeler.length; i++) {
                    this.veri = { id: this.ComboboxGostergeler[i].Id, label: this.ComboboxGostergeler[i].Gostergesi };
                    this.gostergeler[0].children.push(this.veri);
                  }

                  this.sortByLabel();
                });

          });



      } else {
        this.gostergeler = [];
        this.secilen_gostergeler = [];
      }

    
    },

    grafik_tipi(tip) {
      this.grafik_gizle();

      this.secilen_grafik = tip;
    },
    grafik_gizle() {
      this.line_chart = false;
      this.dashed_line_chart = false;
      this.spline_chart = false;
      this.kolon_grafik = false;
      this.column_data_label_chart = false;
      this.bar_chart = false;
      this.line_column_area_chart = false;
      this.radial_chart = false;
      this.pie_chart = false;
      this.donut_chart = false;
    },

/* ANCHOR -- Grafik Yükleme Metodu ----------------------------------------------------- */
    grafik_yukle() {
      if (this.secilen_gostergeler.length > 0) {

        this.grafik_gizle();

        let Page = {
          PageNumber: "1",
          PageSize: "9999",
        };

        let gosterge = "";

        if (this.secilen_gostergeler[0]==1){  // Tümü seçili ise tüm göstergeleri almak

               for (var i = 0; i < this.ComboboxGostergeler.length; i++) {
                gosterge = gosterge + "&TabloDetayIds=" +  this.ComboboxGostergeler[i].Id;
              }

        } else {      // Tümü seçili değilse seçili göstergeleri almak

              for ( i = 0; i < this.secilen_gostergeler.length; i++) {
                gosterge = gosterge + "&TabloDetayIds=" + this.secilen_gostergeler[i];
              }

        }

        let donem = "&PerformansDonemUstId=" + this.Filter.DonemId;
        let Filter = gosterge + donem;

        // Puan giren birim sayısını bulmak için
        let birimler = [];
        this.ActionsFilterGet({ Service: "StrPerfRaporGiris/GrafikDetay", Page: Page, Filter: Filter }).then((res) => {
          for (i = 0; i < res.Data.length; i++) {
            var varmi = birimler.indexOf(res.Data[i].BirimId);
            if (varmi < 0) {
              birimler.push(res.Data[i].BirimId);
            }
          }
      
        

        this.grafik_verisi=[];
        this.ActionsFilterGet({ Service: "StrPerfRaporGiris/Grafik", Page: Page, Filter: Filter }).then((res) => {

          this.gelen_veri=res.Data;
         
          for(var m=0; m<this.tipegore_donemler.length; m++){
              
              for (var t=0;t<res.Data.length;t++){
                
                    if (this.tipegore_donemler[m]==res.Data[t].DonemId){
                      var veri_varmi =  this.grafik_verisi.indexOf(res.Data[t]);
                      if (veri_varmi < 0) {
                          this.grafik_verisi.push(res.Data[t]);
                      }

                    }

                }
          }
        
          

          let donemler = [];
          let gostergeler = [];

          for (i = 0; i < this.grafik_verisi.length; i++) {
              var varmi = donemler.indexOf(this.grafik_verisi[i].DonemAdi);

              if (varmi < 0) {
                  donemler.push(this.grafik_verisi[i].DonemAdi);
              }

              var gostergevarmi = gostergeler.indexOf(this.grafik_verisi[i].Gostergesi);

              if (gostergevarmi < 0) {
                  gostergeler.push(this.grafik_verisi[i].Gostergesi);
              }

          }

          this.secilen_donemler = donemler;

          this.grafik_max_deger = birimler.length * gostergeler.length * 100;

          let series = [];

          let gosterge_adi = "";

          for (var s = 0; s < gostergeler.length; s++) {

            gosterge_adi = gostergeler[s];

            let veriler = [];

            for (i = 0; i < donemler.length; i++) {

                for (var a = 0; a < this.grafik_verisi.length; a++) {

                    if (donemler[i] == this.grafik_verisi[a].DonemAdi && gostergeler[s] == this.grafik_verisi[a].Gostergesi) {

                        veriler.push(this.grafik_verisi[a].Toplam);

                    } 
                  
                }

            }


            series.push({ name: gosterge_adi, data: veriler });

          }

          this.columnChart.series = series;
          this.columnChart.chartOptions.xaxis.categories = donemler;

          this.linewithDataChart.series = series;
          this.linewithDataChart.chartOptions.xaxis.categories = donemler;
          this.linewithDataChart.chartOptions.yaxis.max = this.grafik_max_deger;

          this.barChart.series = series;
          this.barChart.chartOptions.xaxis.categories = donemler;

          //pasta grafik için veri hesaplama

          this.pieChart.chartOptions.labels = donemler;

          series = [];

          gosterge_adi = "";

          for (s = 0; s < gostergeler.length; s++) {
            gosterge_adi = gostergeler[s];

            series = [];

            for (i = 0; i < donemler.length; i++) {
              var donemi_topla = 0;
              for (a = 0; a < this.grafik_verisi.length; a++) {
                if (donemler[i] == this.grafik_verisi[a].DonemAdi) {
                  donemi_topla = donemi_topla + this.grafik_verisi[a].Toplam;
                }
              }
              series.push(donemi_topla);
            }
          }

          this.pieChart.series = series;

          let yeni_data = [];

          for (i = 0; i < series.length; i++) {
            yeni_data.push({ value: series[i], name: donemler[i] });
          }

          if (this.secilen_grafik == 1) {
            this.line_chart = true;
          }
          if (this.secilen_grafik == 2) {
            this.bar_chart = true;
          }
          if (this.secilen_grafik == 3) {
            this.kolon_grafik = true;
          }
          if (this.secilen_grafik == 4) {
            this.pie_chart = true;
          }

            this.detay_goster();

        });
      });
      }
    },
/*ANCHOR -- Detay Göster Metodu -----------------------------------    */
    detay_goster() {
      this.detay_gostergeler = [];
      this.detay_tablolar=[];

      for (var i = 0; i < this.ComboboxGostergeler.length; i++) {
        var varmi = this.secilen_gostergeler.indexOf(this.ComboboxGostergeler[i].Id);

       if(this.secilen_gostergeler[0]==1){varmi=1}


        if (varmi >= 0) {


          let tablo = this.tablolar[0].children.filter(
            (notification) => notification.id.includes(this.ComboboxGostergeler[i].TabloId))[0];

            var varmi_kontrol = this.detay_tablolar.indexOf(tablo);
            if (varmi_kontrol<0 && tablo!=null){
              this.detay_tablolar.push(tablo);
            }

          this.detay_gostergeler.push({ 
            TabloId: this.ComboboxGostergeler[i].TabloId, 
            DetayId:this.ComboboxGostergeler[i].Id, 
            Aciklama: this.ComboboxGostergeler[i].Gostergesi });

        }
      }
    },

    hedef_kontrol(){
      this.tipegore_donemler=[];
      let Filter = "&UstId=" + this.Filter.DonemId;
      this.ActionsFilterGet({ Service: "StrPerfDonem", Page: this.Page, Filter: Filter + "&Asc=Sira" }).then((res) => {
          for(var i=0;i<res.Data.length;i++){

              if(this.hedef_goster==false){
                  if(res.Data[i].VeriTipi==3){
                    this.tipegore_donemler.push(res.Data[i].Id);
                  }
              } else {
                  if(res.Data[i].VeriTipi!=1){
                    this.tipegore_donemler.push(res.Data[i].Id);
                  }
              }

          }

          this.grafik_gizle();
          this.grafik_yukle();
      });

    },

    ExcelExport(table, name){  
        this.excel_kontrol=1;
           
  
        setTimeout(() => {

           if (!table.nodeType) table = this.$refs.GrafikDetayTablosu;
           var html =table.innerHTML  
           var ctx = {worksheet: name || 'Worksheet', table:html }
           var a = document.createElement('a');
           a.href = this.uri +this.base64(this.format(this.template, ctx));
           a.download = name + '.xls';
           a.click();  

           this.excel_kontrol=0;

          }, 1000) 
   

    }, 

    Get() {},



    sortByLabel() {

    this.gostergeler[0].children.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
  },

    sortFunction(a, b) {

        this.gostergeler[0].children.sort(() => {
            if (a.label < b.label) {
              return -1;
            }
            if (a.label > b.label) {
              return 1;
            }
            return 0;
        });
        
    },
    get_pasif_gostergeler(){
          
        
            this.gosterge_yukle()
     
      
       


      }

  



  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    formatDateTable(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },
  },



};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />


      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-lg-8">
              <b-form-group class="mb-3" id="example text" label-cols-lg="2" label="Stratejik Dönem" label-for="text">
                <select v-model="Filter.DonemId" @change="tablo_yukle()" class="form-select" type="text">
                  <option value="">Stratejik Faaliyet Dönemi Seçiniz</option>
                  <option v-for="DonemVerileri in ComboboxDonemler" :key="DonemVerileri.Id" :value="DonemVerileri.Id">
                    {{ DonemVerileri.Aciklama }}
                  </option></select
                >
              </b-form-group>


              <b-form-group class="mb-3" id="example text" label-cols-lg="2" label="Tablolar" label-for="text">
                <treeselect 
                :multiple="true" 
                :options="tablolar" 
                placeholder="Seçiniz..." 
                v-model="secilen_tablolar" 
                @deselect="gosterge_yukle()" 
                @close="gosterge_yukle()"
                
                 />
                <treeselect-value :value="secilen_tablolar" />
              </b-form-group>
              <div class="row">
              <div class="col-lg-2"></div>
                <div class="col-lg-4">
     <div class="form-check">
 
                <input id="checkbox-2" v-model="aktifmi" @click="get_pasif_gostergeler()" class="form-check-input" type="checkbox" name="checkbox-2">
                <label for="checkbox-2" class="form-check-label"> Pasif Göstergeler Listelensin  </label>
              </div>
              </div>
                  </div>

              <b-form-group class="mb-3" id="example text" label-cols-lg="2" label="Göstergeler" label-for="text">
                <treeselect :multiple="true" 
                :options="gostergeler" 
                :sort="sortFunction"
                placeholder="Seçiniz..." 
                v-model="secilen_gostergeler" 
                @close="grafik_yukle(), 
                grafik_tipi(secilen_grafik)" />
                <treeselect-value :value="secilen_gostergeler" />
              </b-form-group>

              <div class="form-check">
                <input id="checkbox-1" v-model="hedef_goster" @click="hedef_kontrol()" class="form-check-input" type="checkbox" name="checkbox-1">
                <label for="checkbox-1" class="form-check-label"> Hedefler Görünsün  </label>
              </div>
                


            </div>
            <br>

            <div class="button-items">
              <button type="button" @click="grafik_yukle(), grafik_tipi(3)" class="btn btn-success">Sütun</button>
              <button type="button" @click="grafik_yukle(), grafik_tipi(1)" class="btn btn-primary">Çizgi</button>
              <button type="button" @click="grafik_yukle(), grafik_tipi(2)" class="btn btn-secondary">Bar</button>
              <button type="button" @click="grafik_yukle(), grafik_tipi(4)" class="btn btn-info">Pasta</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-if="line_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Line with Data Labels chart -->
                    <apexchart class="apex-charts" height="380" type="line" dir="ltr" :series="linewithDataChart.series" :options="linewithDataChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
              <div v-if="dashed_line_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Dashed Line</h4>
                    <!-- Dashed Line Chart -->
                    <apexchart class="apex-charts" height="380" type="line" dir="ltr" :series="dashedLineChart.series" :options="dashedLineChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->

            <div class="row">
              <div v-if="spline_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Spline Area</h4>
                    <!-- Spline Area chart -->
                    <apexchart class="apex-charts" height="350" type="area" dir="ltr" :series="splineAreaChart.series" :options="splineAreaChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
              <div v-if="kolon_grafik" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Column Charts -->
                    <apexchart class="apex-charts" height="350" type="bar" dir="ltr" :series="columnChart.series" :options="columnChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->

            <div class="row">
              <div v-if="column_data_label_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Column with Data Labels -->
                    <apexchart class="apex-charts" height="350" type="bar" dir="ltr" :series="columnDatalabelChart.series" :options="columnDatalabelChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
              <div v-if="bar_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Bar Chart -->
                    <apexchart class="apex-charts" height="350" type="bar" dir="ltr" :series="barChart.series" :options="barChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->

            <div class="row">
              <div v-if="line_column_area_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Line, Column & Area Chart -->
                    <apexchart class="apex-charts" height="350" type="line" dir="ltr" :series="mixedChart.series" :options="mixedChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
              <div v-if="radial_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Radial Chart -->
                    <apexchart class="apex-charts" height="370" type="radialBar" dir="ltr" :series="radialChart.series" :options="radialChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->

            <div class="row">
              <div v-if="pie_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Pie Chart -->
                    <apexchart class="apex-charts" height="370" type="pie" dir="ltr" :series="pieChart.series" :options="pieChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
              <div v-if="donut_chart" class="col-lg-10">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-4">{{ Filter.DonemAdi }}</h4>
                    <!-- Donut Chart -->
                    <apexchart class="apex-charts" height="320" type="donut" dir="ltr" :series="donutChart.series" :options="donutChart.chartOptions"></apexchart>
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>

      <div v-if="grafik_verisi.length > 0" class="col-12">
        <div class="card">
          <div class="card-body">
            <button type="button" @click="detay_goster()" class="btn btn-success">Birim Detay Göster</button>
            
            <br />
            <br />
            
            <div  v-if="detay_gostergeler.length > 0" class="table-responsive">

                <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="
                                            
                        ExcelExport(
                          'Grafik Detay Tablosu',
                          'Grafik Detay Tablosu',
                        )
                       
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Excel'e Aktar
                    </button>
                </div>

         <!--ANCHOR -- Detay Tablo başlangıcı--------------------- -->   

  

         <table ref="GrafikDetayTablosu" class="table table-striped table-bordered mb-0">
          <template v-for="(tablolar, index) in detay_tablolar" >
          <tr 
              :key="index"
             
          >
          <th style="width: 30px;" class="custom-accordion">
                        <a class=" w-100 d-flex align-items-center justify-content-center" 
                        data-toggle="collapse" v-b-toggle="'AltTablo' + index" role="button" 
                        aria-expanded="false" aria-controls="categories-collapse">
                          <i class="mdi mdi-chevron-up accor-down-icon"></i>
                        </a>
            </th>
            <th> {{tablolar.label}}</th>

          </tr>
          <tr  :key="index">
            <td></td>
            <td>
              <b-collapse class="collapse show" :id="'AltTablo' + index">
                <template v-for="(Data, index) in detay_gostergeler" >
                    <table  :key="index"  v-if="Data.TabloId==tablolar.id" class="table table-striped table-bordered mb-0">
  

                    
                      <tbody >
                        <tr colspan="2">
                          <th style="width: 30px;" class="custom-accordion">
                            <a class=" w-100 d-flex align-items-center justify-content-center"
                             data-toggle="collapse" v-b-toggle="'CollapseAltTablo' + Data.DetayId" 
                             role="button" aria-expanded="false" aria-controls="categories-collapse">
                              <i class="mdi mdi-chevron-up accor-down-icon"></i>
                            </a>
                          </th>
                          <th>{{ Data.Aciklama }}</th>
                        </tr>
                        <tr>
                          <td colspan="1"></td>
                          <td colspan="2">
                            <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.DetayId">

                              <PerformansRaporlariDetay :DonemId="Filter.DonemId" :DetayId="Data.DetayId" 
                              :excel_kontrol="excel_kontrol" :TipeGore_Donemler="tipegore_donemler" />
                              
                            </b-collapse>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </b-collapse>
            </td>
          </tr>
        </template>
        </table>

              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
            </div>



          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
